<template>
  <div class="admin-pages">
    <PageTitle
      imagem="Login.png"
      :main="$t('gestao-de-perfis-0')"
      :sub="$t('insercao-e-ou-alteracoes')"
    />
    <div class="-pagesadmin-tabs">
      <ProfileAdmin />
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import ProfileAdmin  from "./ProfileAdmin";

export default {
  name: "ProfilePage",
  components: { PageTitle, ProfileAdmin },
};
</script>

<style scoped>
img {
  max-height: 45px;
}
</style>
